import React, { forwardRef } from 'react';
import { Button } from '@mui/material';
import SingleLineText from './SingleLineText';

// Icons stay at their normal size; only a plain action label fits the remaining width.
const FitButton = forwardRef(function FitButton({ children, ...props }, ref) {
    const isPlainLabel = typeof children === 'string' || typeof children === 'number';
    return <Button {...props} ref={ref}>
        {isPlainLabel ? <SingleLineText component="span" sx={{
            display: 'block', flex: '0 1 auto', font: 'inherit', letterSpacing: 'inherit',
        }}>{children}</SingleLineText> : children}
    </Button>;
});
export default FitButton;
